import { render, staticRenderFns } from "./imby-input.vue?vue&type=template&id=f5efe60e&"
import script from "./imby-input.vue?vue&type=script&lang=js&"
export * from "./imby-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports